export default __webpack_public_path__ + "static/media/logo2.be8469e9.webp";